import React, { useState } from 'react';
import apiClient from '../../apiClient';
import DateFilter from '../../Component/common/datefilter/DateFilter';

import * as XLSX from 'xlsx';

const leadColumns = [
  { key: 'lead_id', label: 'Lead ID' },
  { key: 'posted_on', label: 'Posted On' },
  { key: 'delivery_location', label: 'Delivery Location' },
  { key: 'responded', label: 'Responded' },
  { key: 'response_notes', label: 'Response Notes' },
  { key: 'contact_name', label: 'Contact Name' },
  { key: 'contact_email', label: 'Contact Email' },
  { key: 'contact_phone', label: 'Contact Phone' },
  { key: 'company_name', label: 'Company Name' },
  { key: 'company_website', label: 'Company Website' },
  { key: 'product_name', label: 'Product Name' },
  { key: 'specifications', label: 'Specifications' },
];

const Reports = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedColumns, setSelectedColumns] = useState(leadColumns.map(col => col.key));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleColumnChange = (key) => {
    setSelectedColumns(prev => {
      if (prev.includes(key)) {
        return prev.filter(col => col !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  const fetchLeads = async () => {
    setLoading(true);
    setError('');
    try {
      // Call backend API to get leads filtered by date range
      // Assuming GET /api/leads?fromDate=...&toDate=...
      const params = new URLSearchParams();
      if (fromDate) params.append('fromDate', fromDate);
      if (toDate) params.append('toDate', toDate);
      const response = await apiClient.get(`/api/leads?${params.toString()}`);
      return response.data;
    } catch (err) {
      setError('Failed to fetch leads data');
      return [];
    } finally {
      setLoading(false);
    }
  };

  const exportToExcel = async () => {
    const leads = await fetchLeads();
    if (!leads.length) {
      setError('No leads data to export');
      return;
    }

    // Filter leads data to include only selected columns
    const filteredData = leads.map(lead => {
      const filteredLead = {};
      selectedColumns.forEach(col => {
        filteredLead[col] = lead[col];
      });
      return filteredLead;
    });

    // Create worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');

    // Generate Excel file and trigger download
    XLSX.writeFile(workbook, 'leads_export.xlsx');
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Export Leads Report</h2>
      <DateFilter
        fromDate={fromDate}
        toDate={toDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
      />

      <div style={{ marginBottom: '10px' }}>
        <strong>Select Columns to Export:</strong>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          {leadColumns.map(col => (
            <label key={col.key} style={{ marginRight: '15px' }}>
              <input
                type="checkbox"
                checked={selectedColumns.includes(col.key)}
                onChange={() => handleColumnChange(col.key)}
              />{' '}
              {col.label}
            </label>
          ))}
        </div>
      </div>
      <button onClick={exportToExcel} disabled={loading}>
        {loading ? 'Exporting...' : 'Export to Excel'}
      </button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};

export default Reports;
